import { useLocation, useNavigate } from 'react-router-dom'
import { Form, UpdateFormValue } from '../hooks/useForm'
import useDataError from '../hooks/useDataError'
import Materials from '../steps/Materials'
import Location from '../steps/Location'
import Options from '../steps/Options'
import React, { useRef } from 'react'
import Photo from '../steps/Photo'
import Data from '../steps/Data'

interface FirstViewProps {
  form: Form
  isSending: boolean
  withoutOptions: boolean
  setView: (view: string) => void
  updateFormValue: UpdateFormValue
  handleSubmit: (showOrder?: boolean) => void
}

const FirstView: React.FC<FirstViewProps> = ({
  withoutOptions,
  isSending,
  form,
  setView,
  updateFormValue,
  handleSubmit
}) => {
  const { errors, validateFields } = useDataError(form)
  const { state, pathname, search } = useLocation()
  const step = state?.step ? Number(state.step) : 1

  const navigate = useNavigate()
  const onlyAdd = useRef((() => {
    const query = new URLSearchParams(window.location.search)
    return query.get('onlyAdd')
  })())

  const setStep = (newStep: number) => {
    navigate(`${pathname}${search}`, { state: { ...state, step: newStep } })
  }

  const footerButton = () => {
    if (withoutOptions) {
      return step !== 3
    } else {
      return step !== 3 && step !== 4
    }
  }

  const handleNextStep = () => {
    if (step === 1 && !validateFields()) {
      return
    }
    else if (step === 3 && onlyAdd.current) {
      handleSubmit()
    } else {
      const nextStep = step + 1
      setStep(nextStep)
    }
  }

  const handleStep = (s: number) => {
    if (step === 1 && !validateFields()) {
      return
    }
    setStep(s)
  }

  const materialsElement = <Materials
    inStep
    form={form}
    isSending={isSending}
    handleSubmit={handleSubmit}
    updateFormValue={updateFormValue}
  />

  return (
    <>
      <div className="addProfile__steps">
        <div className={`${step === 1 ? 'active' : ''}`} onClick={() => handleStep(1)}>
          <span>1</span>
          <h2>Dane</h2>
        </div>
        <div className={`${step === 2 ? 'active' : ''}`} onClick={() => handleStep(2)}>
          <span>2</span>
          <h2>Zdjęcie</h2>
        </div>
        <div className={`${step === 3 ? 'active' : ''}`} onClick={() => handleStep(3)}>
          <span>3</span>
          <h2>Lokalizacja</h2>
        </div>
        {!onlyAdd.current && <>
          <div className={`${step === 4 ? 'active' : ''}`} onClick={() => handleStep(4)}>
            <span>4</span>
            <h2>{withoutOptions ? 'Materiały' : 'Opcja'}</h2>
          </div>
        </>}
        {form.showMaterials && <div className={`${step === 5 ? 'active' : ''}`} onClick={() => handleStep(5)}>
          <span>5</span>
          <h2>Materiały</h2>
        </div>}
      </div>

      <div className="addProfile__content">
        {step === 1
          ? <Data
            form={form}
            errors={errors}
            validate={validateFields}
            updateFormValue={updateFormValue}
          />
          : step === 2
            ? <Photo
              selectedImage={form.selectedImage}
              setSelectedImage={selectedImage => {
                updateFormValue('selectedImage', selectedImage)
              }}
            />
            : step === 3
              ? <Location
                gps={form.gps}
                isSending={isSending}
                setGps={gps => {
                  updateFormValue('gps', gps)
                }}
                handleNextStep={handleNextStep}
              />
              : step === 4
                ? withoutOptions
                  ? materialsElement
                  : <Options
                    isSending={isSending}
                    withoutQr={() => handleSubmit(false)}
                    withQr={() => {
                      setView('haveCode')
                    }}
                    buyQrView={() => {
                      updateFormValue('showMaterials', true)
                      handleNextStep()
                    }} />
                : materialsElement}
      </div>

      {footerButton() && <div className="addProfile__footer">
        <button
          className={`btn btn--primary ${isSending ? 'disabled' : ''}`}
          onClick={() => {
            if (step === 5) handleSubmit(true)
            else if (step === 4 && withoutOptions) handleSubmit()
            else handleNextStep()
          }}>
          {isSending ? 'Wysyłanie...' : step === (form.showMaterials ? 5 : 4) ? 'Zapisz' : 'Dalej'}
        </button>
      </div>}
    </>
  )
}

export default FirstView